import { NavigationGuardNext } from "vue-router";
import useDialog from "@/ui/composables/useDialog";

export const unsavedChangesDialog = (
	item: string,
	hasUnsavedChanges: boolean,
	next: NavigationGuardNext,
	callback?: () => void
) => {
	if (!hasUnsavedChanges) {
		callback?.();
		next();
		return;
	}

	(async () => {
		const confirm = await useDialog().confirm({
			title: "Unsaved Changes",
			message: `There are unsaved changes in this ${item}, are you sure you want to discard them?`,
		});

		if (confirm) {
			callback?.();
			next();
		} else {
			next(false);
		}
	})();
};
